import { fetchTeam } from "@/redux/thunks/fetchTeam";
import SvgSelector from "@/shared/UI/SvgSelector";
import { isOrder, isPromo } from "@/shared/constants/routes";
import { breakpoints, mixins } from "@/styles/variables/variables";
import { useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { getTeamKey } from "./getTeamKey";

export const ArtelButtonWithLabel = ({ setOpen }) => {
  const [hovered, setHovered] = useState(false);

  const { pathname } = useRouter();

  const key = getTeamKey(pathname);

  const dataExist = useSelector((state) => Boolean(state.team.data[key]));

  const dispatch = useDispatch();

  const handleClick = () => {
    if (!dataExist) {
      dispatch(fetchTeam(key));
    }
    setOpen(true);
  };

  const isMobile = useMediaQuery(breakpoints.mobile);
  return (
    <>
      <Button
        onClick={handleClick}
        promo={isPromo(pathname) || isOrder(pathname)}
      >
        <ButtonArtel
          onMouseOver={() => setHovered(true)}
          onMouseOut={() => setHovered(false)}
        >
          <SvgSelector svg={"logo-artel-rotate"} />
        </ButtonArtel>
        {isMobile || <Label show={hovered}>Ну мы</Label>}
      </Button>
    </>
  );
};

const ButtonArtel = styled.button`
  & path {
    transition: fill-opacity 0.3s;
  }
  &:hover {
    & path {
      fill-opacity: 0.5;
    }
  }
  &:active {
    & path {
      fill-opacity: 0.4;
    }
  }

  & > svg {
    width: 24px;
    height: 46px;
    @media ${breakpoints.desktopXl} {
      width: 1.876vw;
      height: 3.597vw;
    }
    @media ${breakpoints.tabletL} {
      width: 2.346vw;
      height: 4.497vw;
    }
    @media ${breakpoints.tabletM} {
      width: 3.23vw;
      height: 6.191vw;
    }
    @media ${breakpoints.mobile} {
      width: 7.524vw;
      height: 14.42vw;
    }
  }
`;

const Label = styled.span`
  right: 130%;
  order: -1;
  transform: translateX(10px);
  pointer-events: none;
  opacity: 0;
  transition:
    opacity 0.2s,
    transform 0.5s,
    background-color 0.3s;
  ${mixins.fs12};
  line-height: 120%;
  letter-spacing: 0.24px;
  border-radius: 21px;
  background-color: var(--wh04);
  padding: 5px 12px;
  color: var(--wh6);
  -webkit-backdrop-filter: blur(15px);
  backdrop-filter: blur(15px);
  position: absolute;
  ${({ show }) => show && `opacity: 1; transform: translateX(0) !important; `};
`;

const Button = styled.div`
  position: fixed;
  bottom: 24px;
  right: 25.5px;
  @media ${breakpoints.desktopXl} {
    bottom: 1.88vw;
    right: 1.99vw;
  }
  @media ${breakpoints.tabletL} {
    bottom: 2.35vw;
    right: 2.49vw;
  }
  @media ${breakpoints.tabletM} {
    bottom: 3.23vw;
    right: 3.43vw;
  }
  @media ${breakpoints.mobile} {
    bottom: 7.52vw;
    right: 4.39vw;
    ${({ promo }) => promo && `position: absolute;`}
  }

  z-index: 1301;
  display: flex;
  ${mixins.gap8}
  align-items: center;
  transition: opacity 0.3s;
`;
